import { FC, memo } from "react"
import { ItemCard } from "../ItemCard"
import styles from "./ItemGrid.module.scss"
import { IItemGridProps } from "./types"

const ItemGridComponent: FC<IItemGridProps> = ({ items, onItemClick }) => (
  <div className={styles.ItemGrid}>
    {items.map((item) => (
      <ItemCard key={item.id} item={item} onClick={onItemClick} />
    ))}
  </div>
)

export const ItemGrid = memo(ItemGridComponent)
